import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";

export interface EtudeState {
  etudeId: number | string;
  etudeData?: GetEtudeResponse & { etudeId?: string | number };
  solutions: Solution[];
  acoustique_solution?: boolean;
  noSolution: boolean;
}

const etudeDataString = sessionStorage.getItem("etudeData");
const etudeData: GetEtudeResponse = etudeDataString
  ? JSON.parse(etudeDataString)
  : undefined;

const initialState: EtudeState = {
  etudeId: etudeData?.etudeId ?? 0,
  etudeData,
  solutions: [],
  noSolution: etudeData?.noSolution ?? false,
};

export const etudeSlice = createSlice({
  name: "etude",
  initialState,
  reducers: {
    setEtudeId(state: any, action: PayloadAction<number | string>) {
      state.etudeId = action.payload;
      if (state.etudeData?.etudeId != action.payload) {
        sessionStorage.removeItem("etudeData");
        state.etudeData = undefined;
      }
    },
    clearEtudeId(state: any) {
      state.etudeId = 0;
    },
    setEtudeData(state: any, action: PayloadAction<GetEtudeResponse>) {
      state.etudeData = action.payload;
      sessionStorage.setItem("etudeData", JSON.stringify(action.payload));
    },
    setSolutions(state: any, action: PayloadAction<Solution[]>) {
      (state.solutions as Solution[]) = action.payload;
    },
    setAcoustiqueSolution(state: any, action: PayloadAction<boolean>) {
      state.acoustique_solution = action.payload;
    },
    setNoSolution(state: any, action: PayloadAction<boolean>) {
      state.noSolution = action.payload;
    },
  },
});

export const { setEtudeId, clearEtudeId, setEtudeData, setSolutions, setAcoustiqueSolution, setNoSolution } =
  etudeSlice.actions;
